import { useState as r, useCallback as n, useEffect as l } from "react";
function a(t) {
  const [e, i] = r(!!t), s = n(() => i(!0), []), d = n(() => i(!1), []), w = n(() => i((u) => !u), []);
  return { value: e, setValue: i, setTrue: s, setFalse: d, toggle: w };
}
function c() {
  const [t, e] = r({
    width: typeof window > "u" ? void 0 : window.innerWidth,
    height: typeof window > "u" ? void 0 : window.innerHeight
  });
  return l(() => {
    function i() {
      e({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    return window.addEventListener("resize", i), i(), () => window.removeEventListener("resize", i);
  }, []), t;
}
const o = {
  MOBILE: 640,
  TABLET: 768,
  DESKTOP: 1280
};
function f() {
  const { width: t } = c();
  let e = "desktop";
  return t && t <= o.MOBILE ? e = "mobile" : t && t <= o.TABLET && (e = "tablet"), {
    currentDevice: e,
    isMobile: e === "mobile",
    isTablet: e === "tablet",
    isDesktop: e === "desktop"
  };
}
export {
  f as b,
  a as m
};
